import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles, Tags, Key } from 'lucide-react';
import Layout from '../components/Layout';
import { IntegrationApisPanel } from '../components/admin/IntegrationApisPanel';
import { useLanguage } from '../contexts/LanguageContext';

const AdminIntegrationsPage = () => {
  const { t } = useLanguage();
  return (
    <Layout>
      <div className="max-w-4xl mx-auto fade-in py-2 space-y-4" data-testid="admin-cles-api-page">
        <Link
          to="/admin/identifiants-fournisseurs"
          className="flex items-center gap-2 px-4 py-3 rounded-xl border border-cyan-500/30 bg-cyan-950/20 text-cyan-200 text-sm font-semibold hover:bg-cyan-950/40"
        >
          <Key size={18} />
          {t('adminIntegrations.supplierCredentials')}
        </Link>
        <Link
          to="/admin/stock-photos-ai"
          className="flex items-center gap-2 px-4 py-3 rounded-xl border border-amber-500/30 bg-amber-950/20 text-amber-200 text-sm font-semibold hover:bg-amber-950/40"
        >
          <Sparkles size={18} />
          {t('adminIntegrations.generateStockPhotos')}
        </Link>
        <Link
          to="/admin/stock-category-audit"
          className="flex items-center gap-2 px-4 py-3 rounded-xl border border-cyan-500/30 bg-cyan-950/20 text-cyan-200 text-sm font-semibold hover:bg-cyan-950/40"
        >
          <Tags size={18} />
          {t('adminIntegrations.stockCategoryAudit')}
        </Link>
        <IntegrationApisPanel variant="dark" />
      </div>
    </Layout>
  );
};

export default AdminIntegrationsPage;
